import { render, staticRenderFns } from "./PlaylistSecondary.html?vue&type=template&id=3565f88e&scoped=true&"
import script from "./PlaylistSecondary.vue?vue&type=script&lang=js&"
export * from "./PlaylistSecondary.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistSecondary.css?vue&type=style&index=0&id=3565f88e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3565f88e",
  null
  
)

export default component.exports